import { Component } from '@angular/core';

@Component({
  selector: 'app-filter-icon-factory',
  templateUrl: './filter-icon-factory.component.html'
})
export class FilterIconFactoryComponent {}
